import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import Common from '@/view/common'
import Index from '@/view/index'
import Collection from '@/view/collection'
import Museum from '@/view/museum'
import My from '@/view/my'
import Zhanlan from '@/view/zhanlan'
import News from '@/view/news'
import Activity from '@/view/activity'
import Film from '@/view/film'
import User from '@/view/user'
import Detail from '@/view/detail'
import CollectionDetail from '@/view/collectionDetail'
import MumDetail from '@/view/mumDetail'
import HotDetail from '@/view/hotDetail'
import LastDetail from '@/view/lastDetail'
import ZhanlanDetail from '@/view/zhanlanDetail'
import StudyDetail from '@/view/studyDetail'
import PublicDetail from '@/view/publicDetail'
import AddressMap from '@/view/addressMap'
import Login from '@/view/login'
import Tabdetail from '@/view/tabdetail' //导览详情
import Tabspeaker from '@/view/tabspeaker' //导览详情
import ThemeList from '@/view/themeList' //导览详情
import ThemeDetail from '@/view/themeDetail' //导览详情
import Message from '@/view/message'
import Mine from '@/view/mine'
import Resetpass from '@/view/resetPass'

import Register from '@/view/register'
import Password from '@/view/passWord'

import Nodata from '@/view/noData'
import guideDetail from '@/view/guideDetail'

Vue.use(Router)
Vue.use(VueResource)

export default new Router({
  routes: [
    {
      path: '/',
      name:'Common',
      component: Common,
      children:[
        {path:'',redirect:'index'},
        {path:'index',name:'Index',component:Index},
        {path:'collection',name:'Collection',component:Collection},
        {path:'museum',name:'Museum',component:Museum},
        {path:'my',name:'My',component:My},
        {path:'zhanlan',name:'Zhanlan',component:Zhanlan},
        {path:'news',name:'News',component:News},

        {path:'my/message',name:'Message',component:Message},
        {path:'my/mine',name:'Mine',component:Mine},

        {path:'activity',name:'Activity',component:Activity},
        {path:'my/login',name:'Login',component:Login},
        {path:'my/register',name:'Register',component:Register},
        {path:'my/resetPass',name:'Resetpass',component:Resetpass},
        {path:'my/password',name:'Password',component:Password}
      ]
    },
    {path:'/collectionDetail',name:'CollectionDetail',component:CollectionDetail},
    {path:'/mumDetail',name:'MumDetail',component:MumDetail},
    {path:'/hotDetail',name:'HotDetail',component:HotDetail},
    {path:'/lastDetail',name:'LastDetail',component:LastDetail},
    {path:'/zhanlanDetail',name:'ZhanlanDetail',component:ZhanlanDetail},
    {path:'/studyDetail',name:'StudyDetail',component:StudyDetail},
    {path:'/publicDetail',name:'PublicDetail',component:PublicDetail},
    {path:'/addressMap',name:'AddressMap',component:AddressMap},
    {path:'/nodata',name:'Nodata',component:Nodata},
    {path:'/guideDetail',name:'guideDetail',component:guideDetail},
    {
      title: '语音导览',
      path: '/ThemeList',
      name: 'ThemeList',
      component: ThemeList
    },
    {
      title: '语音导览',
      path: '/ThemeDetail',
      name: 'ThemeDetail',
      component: ThemeDetail
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js